export class ThcAccordionBanner extends HTMLElement {
  #isOpened = false;

  connectedCallback() {
    this.#init();
  }

  #init() {
    this.toggleBtn.addEventListener('click', this.#toggle.bind(this));
  }

  #toggle() {
    this.#isOpened ? this.close() : this.open();
  }

  open() {
    if (this.#isOpened) return;
    this.content.classList.add('open');
    this.toggleBtn.classList.add('open');
    this.#isOpened = true;
  }

  close() {
    if (!this.#isOpened) return;
    this.content.classList.remove('open');
    this.toggleBtn.classList.remove('open');
    this.#isOpened = false;
  }

  get toggleBtn() {
    return this.querySelector('.toggle-accordion');
  }

  get content() {
    return this.querySelector('.accordion-body');
  }
}

if (!customElements.get('thc-accordion-banner')) {
  customElements.define('thc-accordion-banner', ThcAccordionBanner);
}